export default __webpack_public_path__ + "static/media/Metal007_1K_Roughness.5342ff6f.jpg";